// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2iOwO","row":"ProcedureTreatmentSummary_row__1Ihzs"};